/**
 * Search actions.
 * @module actions/search/search
 */

import { LOGIN_CODE, SEND_LOGIN_CODE } from '../../contants/ActionTypes';
/**
 * Send login code function.
 * @function loginCode
 * @param {string} dni DNI.
 */
export function sendCode(dni) {
  return {
    type: SEND_LOGIN_CODE,
    request: {
      op: 'post',
      path: '@sendCode',
      data: { dni },
    },
  };
}

/**
 * Login code function.
 * @function loginCode
 * @param {string} dni DNI.
 * @param {string} code Code.
 */
export function loginCode(dni, code) {
  return {
    type: LOGIN_CODE,
    request: { op: 'post', path: '@loginCode', data: { dni, code } },
  };
}
